import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Image from 'core/components/ContentfulImage';
import { getColor } from 'core/utils';

const AdBlock = styled.a`
	display: flex;
	flex-direction: column;
	margin-left: 32px;
	color: ${getColor("gray")};
	text-decoration: none;

	&:hover, &:active {
		color: ${getColor("gray")};
	}
`;


const AdLabel = styled.div`
	font-size: 14px;
	line-height: 14px;
	letter-spacing: 0.2px;
	font-weight: 600;
	margin-top: 14px;
`;

class SubNavAd extends PureComponent {
	render() {
		return (
			<AdBlock href={this.props.url}>
				<Image src={this.props.image} width={182} height={143} />
				<AdLabel>{this.props.caption}</AdLabel>
			</AdBlock>
		);
	}

	static propTypes = {
		caption: PropTypes.string.isRequired,
		url: PropTypes.string.isRequired,
		image: PropTypes.string.isRequired,
	}
}

export default SubNavAd;
